<template>
  <div class="grid-y">
    <Notification
      v-if="error"
      severity="error"
      class="margin-bottom-xs"
    >
      {{ error.message }}
    </Notification>

    <UpdateBag
      v-if="isUpdateBagEnabled"
      :payload="payload"
      :payload-validator="payloadValidator"
      @error="errorHandler"
    />
    <div
      v-else
      class="cta-buttons"
      :class="{ 'inline': shoppableRedesignOptimization }"
    >
      <AddToBag
        :payload="payload"
        :payload-validator="payloadValidator"
        @error="errorHandler"
      >
        Add To Bag
      </AddToBag>
      <BuyNow
        v-if="buyNow"
        :payload="payload"
        :payload-validator="payloadValidator"
        @error="errorHandler"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Notification from '@atomic-ui/notification';

import {
  AddToBag, BuyNow, UpdateBag,
  useATBPayload, useBagContext,
} from '@modules/add-to-bag';
import { useFeatureEligibility } from '@modules/featureControl';

/**
 * @type {import('vue').Ref<Nullable<Error>>}
 */
const error = ref(null);

const props = defineProps({ // eslint-disable-line no-undef
  atbGiftPayload: {
    /** @type {import('vue').PropType<Partial<ATBGiftPayload>>} */
    type: Object,
    default: () => ({}),
  },
  atbGiftValidator: {
    /**
     * @type {import('vue').PropType<() => Awaitable<Nullable<string>>>}
     */
    type: Function,
    default: null,
  },
});

const { buyNow, shoppableRedesignOptimization } = useFeatureEligibility();
const { isUpdateBagEnabled } = useBagContext();

const {
  payload,
  payloadValidator: basicPayloadValidator,
} = useATBPayload({
  additionalPayload: () => props.atbGiftPayload,
});

const payloadValidator = () => {
  if (typeof props.atbGiftValidator === 'function') {
    return props.atbGiftValidator();
  }
  return basicPayloadValidator();
};

/**
 * @param {Error|null|any} err
 */
const errorHandler = (err) => {
  if (err === null) {
    error.value = null;
    return;
  }
  if (err.message === 'Invalid form') {
    return;
  }
  error.value = err;
};
</script>
